import React from 'react';
import { HeaderIcon, NaviIconSetting } from '@banhala/ui-kit';
import { bridge, useNavigator } from '../../utils';
import { useIsAnonymousUser } from '../../hooks';

interface SettingIconProps {
  screen: string;
}

export const SettingIcon: React.FC<SettingIconProps> = ({ screen }) => {
  const { navigator } = useNavigator();
  const isAnonymouseUser = useIsAnonymousUser();

  const handlePressIconSearch = () => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_SETTING',
      analytics: {
        SCREEN: screen,
      },
    });
    navigator.moveToSetting();
  };
  if (isAnonymouseUser) return null;

  return (
    <HeaderIcon onPress={handlePressIconSearch}>
      <NaviIconSetting />
    </HeaderIcon>
  );
};
